export const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const BANNER_DETAILS_ACTIONS = {
  VIEW: "view",
  EDIT: "edit",
  CREATE: "create",
};

export const BANNER_ACTIONS_HEADER_MAP = {
  [BANNER_DETAILS_ACTIONS.VIEW]: "BANNER DETAILS",
  [BANNER_DETAILS_ACTIONS.EDIT]: "EDIT BANNER DETAILS",
  [BANNER_DETAILS_ACTIONS.CREATE]: "NEW BANNER CREATION",
};

export const BANNER_CARD_ENTITIES = {
  media: "media",
  screen_locations: "screen_locations",
};

export const BANNER_CARD_ENTITY_VALUE_MAP = {
  media: {
    lang_code: "",
    media_type: "IMAGE",
    url: "",
  },
  screen_locations: {
    screen_section_name: "HOME",
    is_carousel: true,
  },
  target_audience: {
    entity_type: "Driver",
    entity_values: [],
  },
};

export const BANNER_CARD_LANGUAGES = [
  {
    name: "English",
    code: "en",
  },
  {
    name: "Hindi",
    code: "hi",
  },
  {
    name: "Tamil",
    code: "ta",
  },
  {
    name: "Telugu",
    code: "te",
  },
  {
    name: "Kannada",
    code: "kn",
  },
  {
    name: "Bengali",
    code: "bn",
  },
  {
    name: "Malayalam",
    code: "ml",
  },
];

export const BANNER_ENTITY_MODES = {
  CREATE: "create",
  EDIT: "edit",
};

export const BANNER_STATUS = [
  "BANNER_STATUS_ACTIVE",
  "BANNER_STATUS_DEACTIVATED",
];

export const BANNER_STATUS_MAP = {
  BANNER_STATUS_ACTIVE: "Active",
  BANNER_STATUS_DEACTIVATED: "Deactivated",
};

export const BANNER_MEDIA_TYPE = ["IMAGE"];

export const BANNER_SCREEN_LOCATIONS = [
  "SCREEN_SECTION_GIGS",
  "SCREEN_SECTION_ASSETS",
  "SCREEN_SECTION_BAZAAR",
  "SCREEN_SECTION_HUB_ANNOUNCEMENTS",
  "SCREEN_SECTION_NAME_HOMEPAGE",
  "SCREEN_SECTION_INSURANCE",
];

export const BANNER_SCREEN_LOCATIONS_MAP = {
  SCREEN_SECTION_GIGS: "Gigs",
  SCREEN_SECTION_ASSETS: "Assets",
  SCREEN_SECTION_BAZAAR: "Bazaar",
  SCREEN_SECTION_HUB_ANNOUNCEMENTS: "Hub Announcements",
  SCREEN_SECTION_NAME_HOMEPAGE: "Homepage",
  SCREEN_SECTION_INSURANCE: "Insurance",
};

export const BANNER_REDIRECTION_TYPES = ["DEEPLINK", "EXTERNAL", "NONE"];

export const BANNER_REDIRECTION_TYPES_MAP = {
  DEEPLINK: "DEEPLINK",
  EXTERNAL: "EXTERNAL",
  NONE: "NONE",
};

export const SAMPLE_CSV_URL = "/sample/bulk_assign_communication.csv";

export const DRIVER_NOTES = [
  "Provide delivery driver IDs (e.g. 34897) as per format given in the sample CSV under entity_id.",
  "We do not accept FE ids. Eg: FE17823 is not acceptable, but 7823 is acceptable",
];

export const CITY_NOTES = [
  "Provide city ids as per format given in the sample CSV under entity_id.",
];

export const LOCALITY_NOTES = [
  "Provide locality ids as per format given in the sample CSV under entity_id.",
];

export const ALL_NOTES = [
  "This action makes the banner PAN-India.",
];


export const TARGETABLE_TYPES = {
  driver: {
    name: "DRIVER",
    code: "driver",
  },
  locality: {
    name: "LOCALITY",
    code: "locality",
  },
  city: {
    name: "CITY",
    code: "city",
  },
  all: {
    name: "ALL",
    code: "all",
  }
};

export const CAROUSEL_MAP = {
  CAROUSEL_TYPE_TOP: "CAROUSEL_TYPE_TOP",
  CAROUSEL_TYPE_BOTTOM: "CAROUSEL_TYPE_BOTTOM",
};

export const CAROUSEL_LABEL_MAP = {
  CAROUSEL_TYPE_TOP: "Top",
  CAROUSEL_TYPE_BOTTOM: "Bottom",
};
